import * as React from "react";
import {useCallback} from "react";
import {classNames, layout, PushButton} from "@variocube/cube-ui";
import {MockToolProps} from "./types";
import {Tool} from "./Tool";

export function PaymentTerminalTool({mockController, align}: MockToolProps) {
    const handleApprovePayment = useCallback(() => {
        mockController.paymentTerminal.approvePayment();
    }, []);

    const handleDenyPayment = useCallback(() => {
        mockController.paymentTerminal.denyPayment();
    }, []);


    return (
        <Tool label="Payment Terminal" align={align}>
            <div className={classNames(layout.paddingLarge, layout.horizontal, layout.alignCenter)}>
                <PushButton onClick={handleApprovePayment} primary>
                    Approve Payment
                </PushButton>
                <PushButton onClick={handleDenyPayment} primary>
                    Deny Payment
                </PushButton>
            </div>
        </Tool>
    )
}
